import type { CustomFormats } from 'react-intl';

const intlFormats: CustomFormats = {
  date: {
    weekdayAndTime: { weekday: 'long', hour: '2-digit', minute: '2-digit' },
    weekdayAndTimeUTC: {
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    },
    weekdayMonthAndTimeUTC: {
      weekday: 'long',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    },
    monthAndTimeUTC: {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    },
    dateAndTime: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    },
    dateAndTimeUTC: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    },
    dateUTC: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      timeZone: 'UTC',
    },
    date: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    hourAndMinute: { hour: '2-digit', minute: '2-digit' },
    hourAndMinuteUTC: { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' },
    longMonth: { year: 'numeric', month: 'long', day: 'numeric' },
    longMonthNoYear: { month: 'long', day: 'numeric' },
    shortMonthAndYear: { year: 'numeric', month: 'short' },
    shortMonthAndYearUTC: { year: 'numeric', month: 'short', timeZone: 'UTC' },
    dateShortMonthAndYear: { year: 'numeric', month: 'short', day: 'numeric' },
  },
};

export default intlFormats;
